import { Fragment } from "react";
import { FlowCard } from "./FlowCard";

import styles from "@styles/pages/flow/FlowList.module.scss";
import { ForEach } from "../../components/control-statements";
import { FlowTableItem } from "./FlowTableItem";

const FLOW_LIST_STYLE = {
  grid: "grid",
  table: "table",
};

export const FlowList = ({
  flows,
  onFlowClick,
  flowStyle = FLOW_LIST_STYLE.grid,
  onLoadFlows,
}) => {
  const FlowsTable = ({ flows, onSelectFlow }) => {
    return (
      <div className={styles.table}>
        <table>
          <tbody>
            <tr>
              <th>Nome do fluxo</th>
              <th>Status</th>
              {/* <th>Qtd. Criativos</th> */}
              <th>Última alteração</th>
              <th />
            </tr>
            <ForEach
              items={flows}
              render={(flow) => (
                <FlowTableItem
                  flow={flow}
                  onClick={(flow) => onSelectFlow && onSelectFlow(flow)}
                />
              )}
            />
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <>
      {flowStyle === FLOW_LIST_STYLE.table && (
        <FlowsTable flows={flows} onSelectFlow={onFlowClick} />
      )}

      {flowStyle === FLOW_LIST_STYLE.grid && (
        <div className={styles.flows}>
          {flows.map((flow, _i) => (
            <Fragment key={_i}>
              <FlowCard
                flow={flow}
                onClick={onFlowClick}
                onLoadFlows={onLoadFlows}
              />
            </Fragment>
          ))}
        </div>
      )}
    </>
  );
};
